// function to act as a class
function CheckBoxCellEditor() { }

//
// Gets called once before the editor is used
//
CheckBoxCellEditor.prototype.init = function (params) {

    this.checkBox = document.createElement('input');
    this.checkBox.type = "checkbox";

    // Store if the user started the editing in this edited
    this.startedHere = params.cellStartedEdit;

    // Check it based on current value
    $(this.checkBox).setChecked(params.value);
};

//
// Gets called once when the grid is ready to insert the element
//
CheckBoxCellEditor.prototype.getGui = function () {
    return this.checkBox;
};

//
// Editor initially created and attached
//
CheckBoxCellEditor.prototype.afterGuiAttached = function () {
    if (this.startedHere) {
        this.checkBox.focus();
    }
};

//
// Tabbing into the cell
//
CheckBoxCellEditor.prototype.focusIn = function () {
    this.checkBox.focus();
};

//
// Returns the new value after editing
//
CheckBoxCellEditor.prototype.getValue = function () {

    // Return current checked value
    return $(this.checkBox).prop("checked");
};